/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Form,
    Input,
    Button,
    notification,
} from 'antd';

import './resetPassword.scss';
import Authentication from '../../components/layouts/Authentication';
import tickPoint from '../../assets/images/tick-point.png';
import tickPointGreen from '../../assets/images/tick-point-green.png';
import useUser from '../../core/user/useUser';

const ResetPassword = ({ match }) => {
    const [passwordLengthPass, setPasswordLengthPass] = useState(false);
    const [passwordLetterNumberPass, setPasswordLetterNumberPass] = useState(false);
    const [passwordContainsUppercase, setPasswordContainsUppercase] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(false);

    const {
        resetPasswordRequest,
        user,
    } = useUser();

    const [form] = Form.useForm();

    const onFinish = (values) => {
        const { password, password_confirmation } = values;

        // Define rules
        setPasswordLengthPass(password && password.length > 7);
        const regExp = /^(?=.*[a-zA-Z])(?=.*[0-9])/;
        setPasswordLetterNumberPass(regExp.test(password));
        const regExpUppercase = /(?=.*[A-Z])/;
        setPasswordContainsUppercase(regExpUppercase.test(password));
        setPasswordMatch(password === password_confirmation);

        // Check rules
        let error = false;

        if (!password || !password_confirmation) {
            notification.error({
                message: 'Error',
                description:
                  'Please enter a new password!',
                onClick: () => {
                    console.log('Notification Clicked!');
                },
            });
            error = true;
        }

        if (!passwordLengthPass || !passwordLetterNumberPass || !passwordContainsUppercase) {
            notification.error({
                message: 'Error',
                description:
                  'Please enter valid password!',
                onClick: () => {
                    console.log('Notification Clicked!');
                },
            });
            error = true;
        }

        if (!passwordMatch) {
            notification.error({
                message: 'Error',
                description:
                  'The passwords do not match!',
                onClick: () => {
                    console.log('Notification Clicked!');
                },
            });
            error = true;
        }

        if (error) {
            return;
        }

        resetPasswordRequest({
            email: match?.params?.email ? match?.params?.email : user?.userData?.email,
            password,
            passwordConfirmation: password_confirmation,
            token: match?.params?.token ? match?.params?.token : user?.userData?.token,
        });
    };

    const onFinishFailed = ({ errorFields }) => {
        form.scrollToField(errorFields[0].name);
    };

    const onValuesChange = (changedValues, allValues) => {
        const { password, password_confirmation } = allValues;

        // Define rules
        setPasswordLengthPass(password && password.length > 7);
        const regExp = /^(?=.*[a-zA-Z])(?=.*[0-9])/;
        setPasswordLetterNumberPass(regExp.test(password));
        const regExpUppercase = /(?=.*[A-Z])/;
        setPasswordContainsUppercase(regExpUppercase.test(password));
        setPasswordMatch(password === password_confirmation);
    };

    return (
        <Authentication>
            <div
                className="ui container reset-password-wrapper"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Form
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    style={{
                        width: '90%',
                        maxWidth: 550,
                    }}
                    layout="vertical">
                    <p
                        className="authentication-title">Reset Password
                    </p>
                    <p className="authentication-subtitle">Create a new password.
                    </p>
                    <div className="horizontal-line" />
                    <Form.Item
                        className="authentication-form-item"
                        label="Password"
                        name="password"
                        help={(
                            <div style={{
                                backgroundColor: '#F4F9FC',
                                borderRadius: 10,
                                marginTop: 10,
                                marginBottom: 10,
                                padding: 20,
                            }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td colSpan={2} style={{ padding: 3 }}>
                                                <p style={{
                                                    color: '#4B4A4A',
                                                    fontFamily: 'Montserrat',
                                                    fontWeight: 600,
                                                    fontSize: '20px',
                                                    lineHeight: '24.38px',
                                                }}>Password must:
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: 3 }}><img src={passwordLengthPass ? tickPointGreen : tickPoint} alt="Sens Train" style={{ marginRight: 10 }} /></td>
                                            <td style={{ width: '100%', padding: 3 }}>
                                                <p style={{
                                                    color: (passwordLengthPass) ? '#228855' : '#4B4A4A',
                                                    fontFamily: 'Open Sans',
                                                    fontWeight: 400,
                                                    fontSize: '20px',
                                                    lineHeight: '27px',
                                                }}>Be at least 8 characters long
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: 3 }}><img src={passwordLetterNumberPass ? tickPointGreen : tickPoint} alt="Sens Train" style={{ marginRight: 10 }} /></td>
                                            <td style={{ width: '100%', padding: 3 }}>
                                                <p style={{
                                                    color: (passwordLetterNumberPass) ? '#228855' : '#4B4A4A',
                                                    fontFamily: 'Open Sans',
                                                    fontWeight: 400,
                                                    fontSize: '20px',
                                                    lineHeight: '27px',
                                                }}>Be a mixture of letters and numbers
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: 3 }}><img src={passwordContainsUppercase ? tickPointGreen : tickPoint} alt="Sens Train" style={{ marginRight: 10 }} /></td>
                                            <td style={{ width: '100%', padding: 3 }}>
                                                <p style={{
                                                    color: (passwordContainsUppercase) ? '#228855' : '#4B4A4A',
                                                    fontFamily: 'Open Sans',
                                                    fontWeight: 400,
                                                    fontSize: '20px',
                                                    lineHeight: '27px',
                                                }}>Contain at least 1 upper case letter
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                        rules={[{
                            required: true,
                            message: 'Please enter your password',
                        }]}>
                        <Input.Password placeholder="Enter password" />
                    </Form.Item>
                    <Form.Item
                        className="authentication-form-item"
                        style={{
                            marginBottom: '50px',
                        }}
                        label="Verify Password"
                        name="password_confirmation"
                        rules={[{
                            required: true,
                            message: 'Please re-enter your password.',
                        }]}>
                        <Input.Password placeholder="Re-enter password" />
                    </Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={user.isFetching}
                        className="authentication-submit">
                        Save Password
                    </Button>
                    <a
                        href="/"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: 10,
                        }}>
                        <u className="authentication-submit-subtext">Back to Login
                        </u>
                    </a>
                </Form>
            </div>
        </Authentication>
    );
};

ResetPassword.propTypes = {
    match: PropTypes.object.isRequired,
};

export default ResetPassword;
